import { ProjectFiles } from "./ProjectFiles"
import ProjectSubmitAdmin from "./ProjectSubmitAdmin"
import { ProjectProcess } from "./ProjectProcess"
import ProjectUpdate from "./ProjectUpdate"
import {
  Button,
  Popconfirm,
  Tag,
  Checkbox,
  Space,
  Tooltip,
  Flex,
  Typography,
} from "antd"
import { Link } from "react-router-dom"
import { StopGasProject } from "./StopGasProject"
import { ProjectRequired } from "./ProjectRequired"
import { ProjectDetail } from "./ProjectDetail"
import {
  CreditCardOutlined,
  DeleteTwoTone,
  FolderOpenOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  FileImageOutlined,
  UserOutlined,
  PhoneOutlined,
  HomeOutlined,
  SendOutlined,
  ToolOutlined,
  CopyOutlined,
} from "@ant-design/icons"
import ProjectPackage from "./ProjectPackage"
import ProjectSendToGas from "./ProjectSendToGas"

const { Text } = Typography
export const renderFileButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectFiles
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderFloorNumber = row => {
  if (row.floorNumber == 0 && row.unitNumber == 1) return <small>همکف</small>
  if (row.floorNumber == 0 && row.unitNumber > 1)
    return <small>چند واحدی</small>
  return row.floorNumber
}

export const renderExeFullName = (row, props) => {
  return row.executor.fullName
}

export const renderProjectProcess = (row, { props }) => {
  return <ProjectProcess rowData={row} mainProps={props} />
}

export const renderSubmitAdminButton = (row, { props, setErrorMessage }) => {
  return (
    <ProjectSubmitAdmin
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderStopGasProjectButton = (row, { props, setErrorMessage }) => {
  return (
    <StopGasProject
      rowData={row}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}
export const renderProjectRequired = (
  params,
  { props, currentUser, userInfo }
) => {
  return (
    <ProjectRequired
      rowData={params}
      mainProps={props}
      currentUser={currentUser}
      userInfo={userInfo}
      isReadOnly={params.projectLevelEnum === 2}
    />
  )
}

export const renderEditButton = (params, { props }) => {
  return <ProjectUpdate rowData={params} mainProps={props} />
}

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}

export const payAmount = params => {
  const payAmount = `${Math.abs(params.projectBalance)}`.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  )
  if (params.projectBalance < 0) return `${payAmount}- ریال`
  return `${payAmount} ریال - بدهی ندارد`
}

export const renderAmountSms = (params, { props }) => {
  const payAmount = `${Math.abs(params.projectBalance)}`.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  )
  return params.projectBalance < 0 && !params.isCancel ? (
    <Popconfirm
      title={`ارسال پیامک جهت واریز مالک: ${params.landlordName} به مبلغ:${payAmount}ریال`}
      description="آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onSendSmsPayment({
          gasProjectId: params.id,
          amount: Math.abs(params.projectBalance),
        })
      }
      okText="بله"
      cancelText="خیر"
    >
      <Tag
        style={{
          cursor: "pointer",
          borderRadius: 4,
          fontSize: 10,
        }}
        color="blue"
      >
        <PhoneOutlined style={{ marginLeft: 2 }} />
        پیامک مالک
      </Tag>
    </Popconfirm>
  ) : null
}
// Export a function called renderDetailButton that takes in two parameters, params and props
export const renderDetailButton = (params, { props }) => {
  // Return a ProjectDetail component with the rowData and mainProps props set to the params and props parameters respectively, and the isReadOnly prop set to true if the projectLevelEnum property of params is equal to 2
  return (
    <ProjectDetail
      rowData={params}
      mainProps={props}
      isReadOnly={params.projectLevelEnum === 2}
    />
  )
}

export const renderDeleteButton = (params, { props }) => (
  <Tooltip title="حذف پرونده">
    <Popconfirm
      title="حذف پرونده"
      description="درصورت عدم تخصیص یا پرداختی قابل حذف می باشد. آیا اطمینان دارید؟"
      onConfirm={() => props.onDeleteGasProject(params.id)}
      okText="بله"
      cancelText="خیر"
      disabled={params.projectLevelEnum !== 0}
    >
      <Button
        disabled={params.projectLevelEnum !== 0}
        icon={
          <DeleteTwoTone
            twoToneColor={params.projectLevelEnum !== 0 ? "#d9d9d9" : "#ff4d4f"}
          />
        }
        type="text"
        size="small"
        style={{ borderRadius: 6 }}
      />
    </Popconfirm>
  </Tooltip>
)

export const renderPackageButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectPackage
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const renderPrepareDesignStageButton = (params, { props }) => {
  return !params.isPrepareForDesignStage ? (
    <Popconfirm
      title={
        params.landlordName +
        " _ " +
        "در صورت تایید واحد گاز مرحله طراحی را تخصیص میدهد"
      }
      description="آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onPrepareForDesignStage({
          gpId: params.id,
          prepare: !params.isPrepareForDesignStage,
        })
      }
      okText="بله"
      cancelText="خیر"
    >
      <Checkbox
        disabled={
          props.loading ||
          props.isStop ||
          props.isCancel ||
          params.projectLevelEnum !== 0 ||
          params.isPrepareForDesignStage ||
          (params.projectLevelEnum === 0 && params.isCancel)
        }
        checked={params.isPrepareForDesignStage}
        style={{ fontSize: 11 }}
      >
        <Text style={{ fontSize: 11 }}>درخواست طراحی</Text>
      </Checkbox>
    </Popconfirm>
  ) : (
    <Tag
      color="success"
      style={{
        borderRadius: 4,
        fontSize: 10,
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <CheckCircleOutlined />
      طراحی: {params.solarPrepareForDesignStage}
    </Tag>
  )
}

export const renderPrepareMapStageButton = (params, { props }) => {
  return !params.isPrepareForMapStage ? (
    <Popconfirm
      title={
        params.landlordName +
        " _ " +
        "در صورت تایید واحد گاز مرحله نقشه را تخصیص میدهد"
      }
      description="آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onPrepareForMapStage({
          gpId: params.id,
          prepare: !params.isPrepareForMapStage,
        })
      }
      disabled={
        props.loading ||
        props.isStop ||
        props.isCancel ||
        (params.projectLevelEnum !== 6 && params.projectLevelEnum !== 1) ||
        params.isPrepareForMapStage ||
        (params.projectLevelEnum === 6 && params.isCancel)
      }
      okText="بله"
      cancelText="خیر"
    >
      <Checkbox
        disabled={
          props.loading ||
          props.isStop ||
          props.isCancel ||
          (params.projectLevelEnum !== 6 && params.projectLevelEnum !== 1) ||
          params.isPrepareForMapStage ||
          (params.projectLevelEnum === 6 && params.isCancel)
        }
        checked={params.isPrepareForMapStage}
        style={{ fontSize: 11 }}
      >
        <Text style={{ fontSize: 11 }}>درخواست نقشه</Text>
      </Checkbox>
    </Popconfirm>
  ) : (
    <Tag
      color="success"
      style={{
        borderRadius: 4,
        fontSize: 10,
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <CheckCircleOutlined />
      نقشه: {params.solarPrepareForMapStage}
    </Tag>
  )
}

export const renderPrepareMapStageButtonV2 = (params, { props }) => {
  return !params.isPrepareForMapStage ? (
    <Popconfirm
      title={
        params.landlordName +
        " _ " +
        "در صورت تایید واحد گاز مرحله نقشه را تخصیص میدهد"
      }
      description="آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onPrepareForMapStage({
          gpId: params.id,
          prepare: !params.isPrepareForMapStage,
        })
      }
      okText="بله"
      cancelText="خیر"
      disabled={
        props.loading ||
        props.isStop ||
        props.isCancel ||
        params.projectLevelEnum !== 1 ||
        params.isPrepareForMapStage ||
        (params.projectLevelEnum === 1 && params.isCancel)
      }
    >
      <Checkbox
        disabled={
          props.loading ||
          props.isStop ||
          props.isCancel ||
          params.projectLevelEnum !== 1 ||
          params.isPrepareForMapStage ||
          (params.projectLevelEnum === 1 && params.isCancel)
        }
        checked={params.isPrepareForMapStage}
        style={{ fontSize: 11 }}
      >
        <Text style={{ fontSize: 11 }}>درخواست نقشه</Text>
      </Checkbox>
    </Popconfirm>
  ) : (
    <Tag
      color="success"
      style={{
        borderRadius: 4,
        fontSize: 10,
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <CheckCircleOutlined />
      نقشه: {params.solarPrepareForMapStage}
    </Tag>
  )
}

export const renderResolvedDefectButton = (params, { props }) => {
  return !params.isSolvedDefect ? (
    <Popconfirm
      title={
        params.landlordName +
        " _ " +
        "در صورت تایید واحد گاز این نقص را تخصیص میدهد"
      }
      description="آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onResolvedDefect({
          gpId: params.id,
          resolved: !params.isSolvedDefect,
        })
      }
      disabled={params.projectLevelEnum !== 3}
      okText="بله"
      cancelText="خیر"
    >
      <Checkbox
        disabled={params.projectLevelEnum !== 3}
        checked={params.isSolvedDefect}
        style={{ fontSize: 11 }}
      >
        <Text style={{ fontSize: 11 }}>رفع نقص</Text>
      </Checkbox>
    </Popconfirm>
  ) : (
    <Tag
      color="success"
      style={{
        borderRadius: 4,
        fontSize: 10,
        display: "flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      <CheckCircleOutlined />
      نقص: {params.solarSolvedDefect}
    </Tag>
  )
}

export const renderPayByExecutorWallet = (params, { props }) => {
  const payAmount = `${Math.abs(params.projectBalance)}`.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  )
  return (
    <Popconfirm
      title={
        params.landlordName +
        " _ " +
        `درصورت تایید مبلغ ${payAmount} ریال از کیف پول پرداخت میشود.`
      }
      description="پس از پرداخت هزینه امکان حذف پرونده یا بازپرداخت وجه آن وجود ندارد.آیا اطمینان دارید؟"
      onConfirm={() =>
        props.onPayByExecutorWallet({
          gpId: params.id,
        })
      }
      disabled={+params.projectBalance >= 0}
      okText="بله"
      cancelText="خیر"
    >
      <Tag
        style={{
          cursor: "pointer",
          borderRadius: 4,
          fontSize: 10,
        }}
        icon={<CreditCardOutlined />}
        color="purple"
      >
        کیف پول
      </Tag>
    </Popconfirm>
  )
}

export const renderSendToGasButton = (params, { props, setErrorMessage }) => {
  return (
    <ProjectSendToGas
      rowData={params}
      mainProps={props}
      setErrorMessage={setErrorMessage}
    />
  )
}

export const projectColumnsAnt = props => {
  const { matches_sm } = props

  // Compact file status component
  const FileStatusBadge = ({ isUploaded, label, shortLabel }) => (
    <Tooltip title={label}>
      <Tag
        color={isUploaded ? "success" : "default"}
        style={{
          borderRadius: 4,
          fontSize: 10,
          padding: "0 4px",
          margin: 1,
          opacity: isUploaded ? 1 : 0.5,
        }}
      >
        {isUploaded ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
        {!matches_sm && <span style={{ marginRight: 2 }}>{shortLabel}</span>}
      </Tag>
    </Tooltip>
  )

  return [
    // Column 1: File Number & Owner
    {
      title: (
        <Flex align="center" gap={4}>
          <FolderOpenOutlined style={{ color: "#667eea" }} />
          <span>پرونده</span>
        </Flex>
      ),
      key: "fileNumber",
      render: params => (
        <div
          style={{
            background: params.isCancel ? "#fff2f0" : "#f6f8fa",
            borderRadius: 8,
            padding: "8px 10px",
            border: params.isCancel ? "1px solid #ffccc7" : "1px solid #e8e8e8",
          }}
        >
          {/* File Number */}
          <Flex>
            <Link to={`/projects/GasProjectExecutor/${params?.id}`}>
              <Button
                type="link"
                icon={<FolderOpenOutlined />}
                iconPosition="end"
                size="small"
                style={{
                  padding: 0,
                  fontFamily: "tahoma",
                  fontWeight: "bold",
                  fontSize: 13,
                  color: "#667eea",
                }}
              >
                {params.fileNumber}
              </Button>
            </Link>
            <Tooltip title="کپی شماره پرونده">
              <Button
                type="text"
                size="small"
                icon={<CopyOutlined />}
                onClick={() => navigator.clipboard.writeText(params.fileNumber)}
              />
            </Tooltip>
          </Flex>

          {/* Owner Name */}
          <div style={{ marginTop: 4 }}>
            <Text style={{ fontSize: 12 }}>
              {params.landlordName}
              <UserOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
            </Text>
          </div>

          {/* Owner Phone Number */}
          <div>
            {params.landlordPhoneNumber ? (
              <a
                href={`tel:${params.landlordPhoneNumber}`}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                <Text style={{ fontSize: 12, cursor: "pointer" }}>
                  {params.landlordPhoneNumber}
                  <PhoneOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />
                </Text>
              </a>
            ) : (
              <Text style={{ fontSize: 12 }}>
                <PhoneOutlined style={{ marginLeft: 4, color: "#8c8c8c" }} />-
              </Text>
            )}
          </div>

          {/* Status Tag */}
          <div style={{ marginTop: 6 }}>
            <Tag
              color={params.isCancel ? "error" : "processing"}
              style={{ borderRadius: 4, fontSize: 10 }}
            >
              {params.isCancel
                ? +params.disapprovalTypeEnum === 0
                  ? params.projectLevel
                  : params.disapprovalTypeName
                : params.projectLevel}
            </Tag>
          </div>
        </div>
      ),
      width: 140,
    },

    // Column 2: Requests
    {
      title: (
        <Flex align="center" gap={4}>
          <SendOutlined style={{ color: "#52c41a" }} />
          <span>درخواست</span>
        </Flex>
      ),
      key: "requests",
      render: params => (
        <Space direction="vertical" size={4} style={{ width: "100%" }}>
          {params.description != "" && (
            <Tooltip title={params.description}>
              <Text
                color="orange"
                style={{
                  fontSize: 11,
                  maxWidth: 100,
                  display: "block",
                }}
                ellipsis={!matches_sm}
              >
                {params.description || "-"}
              </Text>
            </Tooltip>
          )}
          {renderPrepareDesignStageButton(params, props)}
          {params.fileNumber < 240400000 &&
            renderPrepareMapStageButton(params, props)}
          {params.fileNumber > 240400000 &&
            renderPrepareMapStageButtonV2(params, props)}
          {renderResolvedDefectButton(params, props)}
          {params.solarDateSendToCoGas && (
            <Tag color="blue">تاریخ ارسال: {params.solarDateSendToCoGas}</Tag>
          )}
              <Tooltip title={params.des1}>
          <Text
            style={{
              fontSize: 11,
              maxWidth: 100,
              display: "block",
              whiteSpace: matches_sm ? "normal" : undefined,
            }}
            ellipsis={!matches_sm}
          >
            توضیحات: {params.des1 || "-"}
          </Text>
        </Tooltip>
        </Space>
      ),
      width: 160,
    },

    // Column 3: Balance & Payment
    {
      title: (
        <Flex align="center" gap={4}>
          <CreditCardOutlined style={{ color: "#fa8c16" }} />
          <span>مالی</span>
        </Flex>
      ),
      key: "balance",
      render: params => (
        <Space
          direction="vertical"
          size={4}
          align="center"
          style={{ width: "100%" }}
        >
          <Tag
            color={params.projectBalance < 0 ? "error" : "success"}
            style={{
              borderRadius: 6,
              fontSize: 11,
              fontWeight: 500,
              padding: "2px 8px",
            }}
          >
            {payAmount(params)}
          </Tag>
          {renderAmountSms(params, props)}
          {+params.projectBalance < 0 &&
            !params.isCancel &&
            renderPayByExecutorWallet(params, props)}

          {(props.projectLevelEnum === 100 || props.projectLevelEnum === 2) &&
            renderSendToGasButton(params, props)}
        </Space>
      ),
      width: 130,
    },

  

    // Column 5: Actions (Files, Engineer, Installer)
    {
      title: (
        <Flex align="center" gap={4}>
          <ToolOutlined style={{ color: "#722ed1" }} />
          <span>عملیات</span>
        </Flex>
      ),
      key: "actions",
      render: params => (
        <Space
          direction="vertical"
          size={4}
          align="center"
          style={{ width: "100%" }}
        >
          {renderFileButton(params, props)}
          {renderProjectProcess(params, props)}
          {renderPackageButton(params, props)}
        </Space>
      ),
      width: 110,
    },

      // Column 4: File Status
    {
      title: (
        <Flex align="center" gap={4}>
          <FileImageOutlined style={{ color: "#1890ff" }} />
          <span>فایل‌ها</span>
        </Flex>
      ),
      key: "fileStatus",
      render: params => (
        <Flex wrap="wrap" gap={2} justify="center">
          <FileStatusBadge
            isUploaded={params.isUploadIdCard}
            label="کارت ملی"
            shortLabel="ملی"
          />
          <FileStatusBadge
            isUploaded={params.isUploadApprovedPostalCode}
            label="کدپستی"
            shortLabel="پستی"
          />
          <FileStatusBadge
            isUploaded={params.isUploadFirstPlan}
            label="پلان معماری"
            shortLabel="پلان"
          />
          <FileStatusBadge
            isUploaded={params.isUploadIsoPlan}
            label="ایزومتریک"
            shortLabel="ایزو"
          />
        </Flex>
      ),
      width: 100,
    },
    
    // Column 6: Specs
    {
      title: (
        <Flex align="center" gap={4}>
          <HomeOutlined style={{ color: "#13c2c2" }} />
          <span>مشخصات</span>
        </Flex>
      ),
      key: "specs",
      render: params => (
        <Space
          direction="vertical"
          size={4}
          align="center"
          style={{ width: "100%" }}
        >
          <Tag
            color={params.pipingType === "روکار" ? "default" : "gold"}
            style={{ borderRadius: 4, fontSize: 10 }}
          >
            {params.pipingType}{" "}
            {params.hasBurial ? <Text color="brown">دفنی</Text> : ""}
          </Tag>
          <Tag
            color={
              params.buildingType === "تجاری"
                ? "cyan"
                : params.buildingType === "صنعتی"
                ? "orange"
                : "default"
            }
            style={{ borderRadius: 4, fontSize: 10 }}
          >
            {params.buildingType}
          </Tag>
          {renderDetailButton(params, props)}
        </Space>
      ),
      width: 80,
    },

    // Column 7: Unit/Floor
    {
      title: "واحد",
      key: "unit",
      render: params => (
        <Space
          direction="vertical"
          size={2}
          align="center"
          style={{ width: "100%" }}
        >
          <Tag style={{ borderRadius: 4, fontSize: 10, margin: 0 }}>
            {params.unitNumber} واحد
          </Tag>
          <Tag style={{ borderRadius: 4, fontSize: 10, margin: 0 }}>
            {renderFloorNumber(params)}
          </Tag>
          <Text type="secondary" style={{ fontSize: 9 }}>
            {params.inspectionParameterType}
          </Text>
        </Space>
      ),
      width: 60,
    },



    // Column 9: Delete
    {
      title: "",
      key: "delete",
      render: row => renderDeleteButton(row, props),
      width: 40,
    },
  ]
}
